export default [

    {
        path: '*',
        meta: {
            public: true,
        },
        redirect: {
            path: '/'
        }
    },
    {
        path: '/404',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/NotFound.vue`
            )
    },
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/Deny.vue`
            )
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/Error.vue`
            )
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/Login.vue`
            )
    },
    {
        path: '/',
        meta: {},
        name: 'Root',
        redirect: {
            name: 'Dashboard'
        }
    },
    {
        path: '/dashboard',

        name: 'Dashboard',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/Dashboard.vue`
            )
    },
    {
        path: '/settings',

        name: 'Settings',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/settings/Settings.vue`
            )
    },
    {
        path: '/users',

        name: 'Users',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/users/Users.vue`
            )
    },
    {
        path: '/Coupons',

        name: 'Coupons',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/coupons/coupons.vue`
            )
    },
    {
        path: '/ProfileSettings',

        name: 'ProfileSettings',
        component: () =>
            import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy" */
                `@/pages/ProfileSettings.vue`
            )
    }



];